document.addEventListener('DOMContentLoaded', () => {
    const allTabs = document.querySelectorAll('a[data-toggle="tab"]');

    if (!allTabs || allTabs.length === 0) {
        return;
    }

    const ACTIVE_CLASS = 'active';

    // Function to show a specific tab pane and update pagination
    const showTab = (targetId: string) => {
        // Remove active class from all tab panes
        const allTabPanes = document.querySelectorAll('.tab-pane');
        allTabPanes.forEach((pane) => {
            pane.classList.remove(ACTIVE_CLASS);
        });

        // Show the target tab pane
        const targetPane = document.querySelector(targetId);
        if (targetPane) {
            targetPane.classList.add(ACTIVE_CLASS);
        }

        // Remove active class from all pagination links
        allTabs.forEach((pageLink) => {
            pageLink.classList.remove(ACTIVE_CLASS);
            pageLink.setAttribute('aria-selected', 'false');
            // Also remove from parent li if it exists
            const parentLi = pageLink.closest('.page-item');
            if (parentLi) {
                parentLi.classList.remove(ACTIVE_CLASS);
            }
        });

        // Add active class to the clicked pagination link
        const activeLink = document.querySelector(`a[data-toggle="tab"][href="${targetId}"]`);
        if (activeLink) {
            activeLink.classList.add(ACTIVE_CLASS);
            activeLink.setAttribute('aria-selected', 'true');
            // Also add to parent li if it exists
            const parentLi = activeLink.closest('.page-item');
            if (parentLi) {
                parentLi.classList.add(ACTIVE_CLASS);
            }
        }
    };

    // Handle click events on pagination links
    allTabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            const href = tab.getAttribute('href');
            if (href && href.startsWith('#')) {
                showTab(href);
                // Update URL hash without scrolling using pushState
                if (window.history.pushState) {
                    window.history.pushState(null, '', href);
                } else {
                    window.location.hash = href;
                }
            }
        });
    });

    // Handle hash changes (back/forward buttons and initial load)
    const handleHashChange = () => {
        const hash = window.location.hash;
        if (hash && hash.startsWith('#user-reviews-')) {
            // Save current scroll position
            const scrollY = window.scrollY;
            showTab(hash);
            // Restore scroll position to prevent auto-scroll
            // Use requestAnimationFrame to ensure it happens after any browser scroll
            requestAnimationFrame(() => {
                window.scrollTo(0, scrollY);
            });
        }
    };

    // Check hash on initial load
    handleHashChange();

    // Listen for hash changes (back/forward buttons)
    window.addEventListener('hashchange', handleHashChange);
});
